import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/smartshore.webp';
import screenshot_target from '../../../images/letterfunnel/jelkeschippers.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Jelke Schippers"
      firstname="Jelke"
      companyname="Smartshore"
      competition="Gapstars en Daxx"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/jelkeschippers.js